import { Orientation } from "@opstel/query/v2/models/action";

export class TrainUnitList<T> {
  constructor(private readonly trainUnitsFromSourceToTarget: T[]) {}
  public get length(): number {
    return this.trainUnitsFromSourceToTarget.length;
  }

  public fromSourceToTarget(currentOrientation: Orientation): T[] {
    return currentOrientation === "FirstUnitOnSourceSide"
      ? this.trainUnitsFromSourceToTarget
      : this.trainUnitsFromSourceToTarget.toReversed();
  }

  public inAnyDirection(): T[] {
    return this.trainUnitsFromSourceToTarget;
  }
}
